import { Newsletter } from '@client/types'
import getBaseUrl from '@utils/getBaseUrl'
import axios from 'axios'
import {
  FetchChronoPayload,
  FetchScreenPayload,
  FetchSearchPayload,
  FetchSpecialPayload
} from 'types/storeTypes'

const apiClient = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  baseURL: getBaseUrl()
})

// TODO: вынести роуты в отдельный файл
const getStatUrl = (key: string) => `/stat/put${key}?client=website`
const getScreenUrl = (name: string, lang?: string) =>
  `/api/v1${lang === 'en' ? '/en' : ''}/screens/${name}`
const getSpecialUrl = (slug: string) => `/api/v1/screens/specials/${slug}`
const getChronoUrl = (screenName: string, page: number, lang: string) =>
  `/api/v1/screens/latest`
const getSearchUrl = (query: string, page: number, lang: string) =>
  `/api/v1/search?term=${query}&page=${page}&per_page=24&locale=${lang}`

export function* sendStat(key: string) {
  return yield apiClient.get(getStatUrl(key))
}

export function* fetchScreen({ name, lang }: FetchScreenPayload): unknown {
  return yield apiClient.get(getScreenUrl(name, lang))
}

export function* fetchSpecials({ slug }: FetchSpecialPayload): unknown {
  return yield apiClient.get(getSpecialUrl(slug))
}

export function* fetchExchangeRates(): unknown {
  return yield apiClient.get(`api/misc/stock/all`)
}

export function* subscribeToDaily(
  params: URLSearchParams,
  lang: Newsletter
): unknown {
  return yield apiClient.post(`/digests/${lang}/captcha`, params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export function* getFeedbackToken(): unknown {
  return yield apiClient.get('/embed/feedback/meduza/token', {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export function* sendTextError(data: {
  comment: string
  key: string
  before: string
  after: string
  error: string
}): unknown {
  return yield apiClient.post('/api/spelling', data, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
}

export function* sendReaction(data: {
  csrf: string
  payload: {
    key: string
    email: string
    text: string
    tag: string
    type: string
  }
}): unknown {
  return yield apiClient.post('/embed/feedback/meduza/reaction', data)
}

export function* fetchChrono({
  screenName,
  lang,
  page = 0
}: FetchChronoPayload): unknown {
  return yield apiClient.get(getChronoUrl(screenName, page, lang))
}

export function* fetchSearch({
  query,
  lang,
  page = 0
}: FetchSearchPayload): unknown {
  return yield apiClient.get(getSearchUrl(query, page, lang))
}

export function* fetchMaterial(url: string): unknown {
  return yield apiClient.get(`/api/v1/${url}`)
}

export function* fetchUnderTheSun(): unknown {
  return yield apiClient.get(`/api/v1/screens/news`)
}

export function* deleteUserRequest(token: string): unknown {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`

  return yield apiClient.delete(`/api/paywall/user`)
}
